import Route from '@ember/routing/route';
import { type NewsletterRouteModel } from '../newsletter';
import { service } from '@ember/service';
import RouterService from '@ember/routing/router-service';

export default class NewsletterRoute extends Route {
  @service declare router: RouterService;

  redirect(model: NewsletterRouteModel) {
    if (model.newsletterAccount != null) {
      this.router.transitionTo('funds.fund.more.newsletter.connected');
    }
  }
}
